import {
  SET_ASSESSMENT_REDIRECT_PATH,
  RESET_ASSESSMENT_REDIRECT_PATH,
} from "./actions-types";
import {
  sendWelcomeEmail,
  sendValidateCodeEmail,
  validateEmailCode,
} from "../services";
import { getErrorMessageFromRequestError } from "../../shared/helpers/messages/request";

import {
  setFetching,
  setError,
} from "../../shared/request/actions/requestActions";

export const resetRedirectPath = () => ({
  type: RESET_ASSESSMENT_REDIRECT_PATH,
});

export const setRedirectPath = (redirectTo) => ({
  type: SET_ASSESSMENT_REDIRECT_PATH,
  payload: redirectTo,
});

export const asyncSendWelcomeEmail = (email) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    await sendWelcomeEmail(email);
    dispatch(
      setError({
        isOpen: false,
        message: "The email request was made successful",
        type: "success",
      })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncSendValidateCodeEmail = (email) => async (dispatch) => {
  dispatch(setFetching({ isFetching: true }));
  try {
    await sendValidateCodeEmail(email);
    dispatch(
      setError({
        isOpen: false,
        message: "The email request was made successful",
        type: "success",
      })
    );
  } catch (error) {
    const message = getErrorMessageFromRequestError(error);
    dispatch(setError({ isOpen: true, message, type: "error" }));
  } finally {
    dispatch(setFetching({ isFetching: false }));
  }
};

export const asyncValidateEmailCode =
  (email, participantKey) => async (dispatch) => {
    dispatch(setFetching({ isFetching: true }));
    try {
      const response = await validateEmailCode(email, participantKey);
      dispatch(setRedirectPath(response.data.data));
    } catch (error) {
      const message = getErrorMessageFromRequestError(error);
      dispatch(setError({ isOpen: true, message, type: "error" }));
    } finally {
      dispatch(setFetching({ isFetching: false }));
    }
  };
